module.exports = __webpack_public_path__ + "static/media/alert.55509c14.svg";


//////////////////
// WEBPACK FOOTER
// ./public/assets/icons/alert.svg
// module id = 961
// module chunks = 0